import $ from 'cash-dom';

export const ziadostOPravneZastupovanieFormComponent = async () => {
  $('#form-ziadost-o-pravne-zastupovanie').each((n, el) => {
    const $el = $(el);
    console.log($el);

    const $radiosType = $el.find('.input-radio-type');
    const $radiosInsuredType = $el.find('.input-radio-insured-type');
    const $radiosLegalRepresentationType = $el.find('.input-radio-legal-representation-type');

    $radiosType.eq(0).on('change', () => {
      $el.find('.section-hidden').removeClass('hidden');
      $el.find('.insured-type-title').text('Ste');
    });
    $radiosType.eq(1).on('change', () => {
      $el.find('.section-hidden').removeClass('hidden');
      $el.find('.insured-type-title').text('Poistený je');
    });

    $radiosInsuredType.eq(0).on('change', () => {
      $el.find('#insured_name_title').text('Meno, priezvisko');
      $el.find('#insured_ico_container').addClass('hidden');
      $el.find('#insured_ico').removeAttr('required');
    });
    $radiosInsuredType.eq(1).on('change', () => {
      $el.find('#insured_name_title').text('Názov spoločnosti');
      $el.find('#insured_ico_container').removeClass('hidden');
      $el.find('#insured_ico').attr('required', 'required');
    });

    $radiosLegalRepresentationType.eq(0).on('change', () => {
      $el.find('#legal_representation_container').removeClass('hidden');
      $el.find('#legal_representation').attr('required', 'required');
    });

    $radiosLegalRepresentationType.eq(1).on('change', () => {
      $el.find('#legal_representation_container').addClass('hidden');
      $el.find('#legal_representation').removeAttr('required');
    });
  });
};
